var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgOutsiteLink = function SvgOutsiteLink(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#116069",
    width: 20.5,
    height: 20.5,
    viewBox: "0 0 20.5 20.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "full-screen",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2890",
    "data-name": "Group 2890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2889",
    "data-name": "Group 2889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77462",
    "data-name": "Path 77462",
    d: "M108.379,0V2.222h3.983L101.44,13.144l1.572,1.572L113.934,3.794V7.778h2.222V0Z",
    transform: "translate(-96.157)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77463",
    "data-name": "Path 77463",
    d: "M17.778,17.778H2.222V2.222H10V0H2.222A2.222,2.222,0,0,0,0,2.222V17.778A2.222,2.222,0,0,0,2.222,20H17.778A2.222,2.222,0,0,0,20,17.778V10H17.778Z",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOutsiteLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/outsite-link.2165abe8.svg";
export { ForwardRef as ReactComponent };